<template>
  <div>
    <h2>{{ status }}</h2>
    <p v-if="subscriptionId">Subscription ID: {{ subscriptionId }}</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";


export default {
  data() {
    return {
      status: '',
      subscriptionId: null,
    }
  },
  async created() {
    const token = this.$route.query.token

    if (!token) {
      this.status = 'Missing token in URL'
      return
    }
    var response = await this.GetMicrosoftActivateToken(token);
    
    if(response != undefined){
        this.subscriptionId = response.data.subscriptionId
        this.status = 'Subscription resolved successfully!'
    }
    else{
         this.status = 'Failed to resolve subscription.'  
    }
  },
  methods:{
    ...mapActions(["GetMicrosoftActivateToken"]),
  }

}
</script>
